import { BulletinType } from '../masters/bulletin-type/bulletin-type';
import { Vehicle } from '../masters/vehicle/vehicle';
import { RepairGroup } from '../masters/repair-group/repair-group';
import { VehicleBrand } from '../masters/vehicle-brand/vehicle-brand';
import { Role } from '../masters/role/role';

export class BulletinFilter {
    code: string;
    description: string;
    year: number;
    bulletinType: BulletinType;
    vehicle: Vehicle;
    repairGroup: RepairGroup;
    vehicleBrand: VehicleBrand;
    role: Role;
    status: number;
    startDate: string;
    endDate: string;
    updateDate: string;


    internalUser: Boolean;
}